import * as type from "./constants";

export function createFcnQuery(payload, onSuccess) {
  return {
    type: type.CREATE_FCN_QUERY,
    payload,
    onSuccess,
  };
}
